interface WaveObserverSettings {
  enabled: boolean
  wave: number
  heroId: string
}

interface WaveObserverEnvelope<T = unknown> {
  source: "bttf-wave-observer"
  type: string
  payload: T
  ts: number
}

function getSearchParams(): URLSearchParams | null {
  if (typeof window === "undefined") return null
  return new URLSearchParams(window.location.search)
}

export function getWaveObserverSettings(): WaveObserverSettings {
  const params = getSearchParams()
  if (!params) {
    return { enabled: false, wave: 1, heroId: "bella" }
  }

  const observer = params.get("observer")
  const enabled = observer === "wave" || observer === "waves"
  const requestedWave = Number(params.get("wave") ?? "1")
  const wave =
    Number.isFinite(requestedWave) && requestedWave > 0
      ? Math.floor(requestedWave)
      : 1
  const heroId = params.get("hero")?.trim() || "bella"

  return {
    enabled,
    wave,
    heroId,
  }
}

function isWaveObserverEnabled(): boolean {
  return getWaveObserverSettings().enabled
}

export function postWaveObserverMessage<T>(type: string, payload: T): void {
  if (typeof window === "undefined") return
  if (!isWaveObserverEnabled()) return
  if (window.parent === window) return

  const message: WaveObserverEnvelope<T> = {
    source: "bttf-wave-observer",
    type,
    payload,
    ts: Date.now(),
  }

  window.parent.postMessage(message, "*")
}
